<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-button
          v-if="is_general_manager || is_support || is_climbing_supervisor|| is_sales_supervisor"
          @click.native="onButtonCreate"
        >
          Create group
        </app-button>
        <app-input
          @input.native="onGroupsSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search by group name"
          name="search"
        />
        <app-date-picker
          @input="onChangeFilter"
          v-model="filter_start"
          placeholder="From"
          class="datepicker--filter"
        />
        <app-date-picker
          @input="onChangeFilter"
          v-model="filter_end"
          placeholder="To"
          class="datepicker--filter"
        />
        <app-checkbox
          v-if="is_sales_manager"
          v-model="filter_clients"
          @change="onChangeFilter"
          label="My clients"
        />
      </app-cells>
      <div v-for="climbing_table_item of climbing_table" :key="climbing_table_item.name" class="climbing-block">
        <app-cells v-if="climbing_table_item.name">
          <h2 class="title">{{ climbing_table_item.name }}</h2>
          <div v-if="climbing_table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
          :data="climbing_table_item.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
          @row-click="openGroupPreview"
        >
          <template #h__route.name><div class="table-default__left">Route</div></template>
          <template #h__chief_guide><div class="table-default__left">Guide</div></template>
          <template #h__name><div class="table-default__left">Name</div></template>
          <template #h__start><div class="table-default__left">Meeting</div></template>
          <template #h__type><div class="table-default__left">Type</div></template>
          <template #h__tents><div class="table-default__left">Tents</div></template>
          <template #h__toilet>Portable<br>toilets</template>
          <template #h__showers>Portable<br>showers</template>
          <template #h__porters>Personal<br>porters</template>
          <template #h__phone>Satellite<br>phone</template>
          <template #h__water>Bottled<br>water</template>
          <template #count="{row, index}">{{ index }}</template>
          <template #name="{ row }">
            <div class="table-default__left">
              <router-link
                :to="{ name: 'climbing-groups-detail-clients', params: { id: row.id } }"
                class="table-default__link-border table-default__link-border--inline"
              >
                {{ row.name }}
              </router-link> ({{ row.pax }})
            </div>
          </template>
          <template #start="{ row }">
            <div class="table-default__controls table-default__left">
              <span v-if="row.meeting_time && row.starting_point">
                {{ row.meeting_time }} at
                <span v-if="row.starting_point.place_id !== 'ChIJqQRrDoleNxgRANW_07pTSXY'" class="status-tag" :style="{ 'backgroundColor': '#439ad1' }">{{ row.starting_point.short_name }}</span>
                <span v-else>{{ row.starting_point.short_name }}</span>
              </span>
              <span v-else>-</span>
            </div>
          </template>
          <template #tents="{ row }">
            <div class="table-default__controls table-default__left">
              <span
                v-if="!row.route.accommodation_type"
                class="status-tag"
                :style="{'backgroundColor': '#439ad1'}"
              >
                None
              </span>
              <template v-else>
                <span
                  v-if="is_general_manager || is_climbing_department"
                  class="status-tag"
                  :style="{ 'backgroundColor': row.tents.clients_allocated === row.pax ? '#77b017' : '#e85c20' }"
                >
                  {{ row.tents.count  }}
                </span>
                <span
                  v-if="!is_climbing_department"
                  class="status-tag"
                  :style="{ 'backgroundColor': row.tents.clients_allocated === row.pax ? '#77b017' : '#e85c20' }"
                >
                  {{ row.tents.clients_allocated ? row.tents.clients_allocated : 0 }} / {{ row.pax }}
                </span>
              </template>
            </div>
          </template>
          <template #type="{ row }">
            <div class="table-default__left">
              <span class="status-tag" :style="{ 'backgroundColor': row.type.color || '#8a8a8a' }">
                {{ row.type ? row.type.name : '-' }}
              </span>
            </div>
          </template>
          <template #route.name="{ row }">
            <div class="table-default__left">{{ row.route.name }} {{ row.route.duration }}</div>
          </template>
          <template #chief_guide="{ row }">
            <div class="table-default__left">
              {{ row.chief_guide ? row.chief_guide.full_name : '-' }}
            </div>
          </template>
          <template #toilet="{ row }">
            <span v-if="row.additional_services.toilet" class="status-tag" :style="{ backgroundColor: '#424242' }">
              {{ row.additional_services.toilet }}
            </span>
            <span v-else>-</span>
          </template>
          <template #showers="{ row }">
            <span v-if="row.additional_services.shower" class="status-tag" :style="{ backgroundColor: '#424242' }">
              {{ row.additional_services.shower }}
            </span>
            <span v-else>-</span>
          </template>
          <template #porters="{ row }">
            <span v-if="row.additional_services.porter" class="status-tag" :style="{ backgroundColor: '#424242' }">
              {{ row.additional_services.porter }}
            </span>
            <span v-else>-</span>
          </template>
          <template #phone="{ row }">
            <span v-if="row.additional_services.phone" class="status-tag" :style="{ backgroundColor: '#424242' }">
              {{ row.additional_services.phone }}
            </span>
            <span v-else>-</span>
          </template>
          <template #water="{ row }">
            <span v-if="row.additional_services.water" class="status-tag" :style="{ backgroundColor: '#424242' }">
              {{ row.additional_services.water }}
            </span>
            <span v-else>-</span>
          </template>
          <template #info="{ row }">
            <div class="table-default__controls">
              <span
                v-if="is_general_manager || is_climbing_department"
                v-tooltip="{content: row.notes_climbing_manager, placement: 'left', offset: 10}"
                class="table-default__activity table-default__activity--notes"
                :class="{'table-default__activity--active': row.notes_climbing_manager}"
              />
              <a
                :href="`${row.gps?.shared_link}`"
                target="_blank"
                class="table-default__activity table-default__activity--gps"
                :class="{'table-default__activity--active': row.gps}"
              />
            </div>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
    <modal
      name="climbing-group-form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('climbing-group-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Create Climbing group</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Group name" label-for="name" required>
              <app-input
                v-model="form.name"
                @change.native="$v.form.name.$touch()"
                :error="$v.form.name.$error"
                id="group_name"
                placeholder="Group name"
                name="group_name"
              />
              <template #error>
                <div v-if="$v.form.name.$dirty && !$v.form.name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Route" required>
              <app-select
                v-model="form.route"
                :reduce="item => item.id"
                :options="routes_options"
                :display-field="option => `${option.name} ${option.duration}`"
                placeholder="Route"
                :error="$v.form.route.$error"
              />
              <template #error>
                <div v-if="$v.form.route.$dirty && !$v.form.route.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Type" required>
              <app-select
                v-model="form.type"
                :reduce="item => item.code"
                :options="group_type_options"
                :clearable="false"
                placeholder="Type"
                :error="$v.form.type.$error"
              />
              <template #error>
                <div v-if="$v.form.type.$dirty && !$v.form.type.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Tour start" required>
              <app-date-picker
                v-model="form.tour_start"
                placeholder="Tour start"
                :error="$v.form.tour_start.$error"
              />
              <template #error>
                <div v-if="$v.form.tour_start.$dirty && !$v.form.tour_start.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getClimbingGroupsByDates, getClimbingGroupType, getClimbingRoutes, postClimbingsGroups } from '@/http'
import debounce from 'lodash/debounce'
import { required } from 'vuelidate/lib/validators'
import { format, parse } from 'date-fns'
import previewRow from './previewRow'

export default {
  name: 'ClimbingGroupsList',
  mixins: [previewRow],
  data() {
    return {
      is_loaded: false,
      search: null,
      climbing_table: [],
      table_length: 0,
      table: {
        items: [],
        columns: ['count', 'name', 'start', 'tents', 'type', 'route.name', 'info'],
        options: {
          headings: {
            'count': '#',
            'name': 'Name',
            'start': 'Meeting',
            'tents': 'Tents',
            'type': 'Type',
            'route.name': 'Route',
            'chief_guide': 'Guide',
            'toilet': 'Portable toilets',
            'showers': 'Portable showers',
            'porters': 'Personal porters',
            'phone': 'Satellite phone',
            'water': 'Bottled water',
            'info': 'Info',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {},
      routes_options: [],
      group_type_options: [],
      filter_start: null,
      filter_end: null,
      filter_clients: false,
      table_preloader: false,
    }
  },
  validations: {
    form: {
      name: { required },
      route: { required },
      type: { required },
      tour_start: { required },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_support() {
      return this.$store.state.userGroups.map(item => item.code).includes('support')
    },
    is_climbing_department() {
      return this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_assistant')
    },
    is_climbing_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_operations_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_manager')
    },
  },
  created() {
    if (this.is_operations_manager) this.table.columns.splice(6, 0, 'chief_guide')
    if (this.is_general_manager || this.is_climbing_department) this.table.columns = ['count', 'name', 'start', 'tents', 'type', 'route.name', 'chief_guide', 'toilet', 'showers', 'porters', 'phone', 'water', 'info']
    this.fetchItems()
    getClimbingRoutes().then(res => { this.routes_options = res.data })
    getClimbingGroupType().then(res => {
      this.group_type_options = res.data
      if (this.group_type_options.length) this.form.type = this.group_type_options[0].code
    })
  },
  methods: {
    onChangeFilter() {
      this.pagination.page = 1
      this.search = ''
      this.fetchItems()
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onButtonCreate() {
      this.form = {
        type: this.group_type_options[0].code
      }
      this.$v.form.$reset()
      this.$modal.show('climbing-group-form')
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM') : '-'
    },
    fetchItems() {
      const params = {
        page: this.pagination.page,
        page_size: 40,
        search: this.search,
        category: this.search ? '' : 'upcoming',
        group_by: 'tour_start',
        range_type: 'day',
        my_clients: this.search || !this.is_sales_manager ? '' : this.filter_clients,
        ordering: 'tour_start,meeting_time'
      }
      if (!this.search && this.filter_start) params['tour_start__gte'] = this.filter_start
      if (!this.search && this.filter_end) params['tour_start__lte'] = this.filter_end
      getClimbingGroupsByDates(params)
        .then(res => {
          this.climbing_table = res.data.results.length ? res.data.results : [{name: '', items: []}]
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.table_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onGroupsSearch() {
      this.table_preloader = true
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
    onCheckForm () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      postClimbingsGroups(this.form)
        .finally(() => { this.$refs.submit.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Group created',
          })
          this.$modal.hide('climbing-group-form')
          this.form = {
            type: this.group_type_options[0].code
          }
          this.fetchItems()
        })
    },
  }
}
</script>

<style lang="sass" scoped>
.climbing-block
  margin-bottom: 30px
</style>
